import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Syskc { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '日期 (KC001) 不可空白'}) 
    @MaxLength(8,{message: '日期 (KC001) 資料太長'})
    KC001: string = '';            // 日期 8 

    @IsNotEmpty({message: '時間 (KC002) 不可空白'}) 
    @MaxLength(4,{message: '時間 (KC002) 資料太長'})
    KC002: string = '';            // 時間 4 

    @IsNotEmpty({message: '簽收人 (KC003) 不可空白'}) 
    @MaxLength(10,{message: '簽收人 (KC003) 資料太長'})
    KC003: string = '';            // 簽收人 10 員工代號

    @MaxLength(255,{message: '我要回應 (KC004) 資料太長'})
    KC004: string = '';            // 我要回應 255 


    KC005: Date | undefined;            // 簽收時間 0 

    @MaxLength(255,{message: '發佈人回覆 (KC006) 資料太長'})
    KC006: string = '';            // 發佈人回覆 255 


}
